import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { AuthNoticeService } from '../../../core/auth';
import { HttpClient } from '@angular/common/http';
import { TransportService } from '../../../core/e-commerce/_services/transport.service';
import { CountryService } from '../../../service/country.service';

@Component({
    selector: 'kt-dialog-product',
    templateUrl: './dialog-transport.component.html',
    styleUrls: ['./dialog-transport.component.scss'],
})
export class DialogTransportComponent implements OnInit {

    detailForm: FormGroup;
    error: boolean = false;
    isLoadingResults = false;
    isActive = [
        {
            value: true,
            name: 'Activo',
        },
        {
            value: false,
            name: 'Inactivo',
        },
    ];
    routes = [];
    routeInput: FormControl = new FormControl();
    provincias;

    constructor(
        private service: TransportService,
        private _snackBar: MatSnackBar,
        private cdr: ChangeDetectorRef,
        public dialogRef: MatDialogRef<DialogTransportComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private fb: FormBuilder,
        private authNoticeService: AuthNoticeService,
        private countryService: CountryService
    ) {
    }

    ngOnInit() {
        this.authNoticeService.setNotice(null);
        this.getStructure();
        this.initForms();
    }

    initForms() {
        let model;
        if (this.data) {
            model = this.data;
            this.routes = this.data.routes;
        } else {
            model = {};
        }

        this.detailForm = this.fb.group({
            // id: [model.id, Validators.required],
            code: [model.code, Validators.required],
            name: [model.name, Validators.required],
            address: [model.address, Validators.required],
            openingHours: [model.openingHours, Validators.required],
            province: [model.province, Validators.required],
            locality: [model.locality, Validators.required],
            phone: [model.phone, Validators.required],
            orderHoldDays: [model.orderHoldDays, Validators.required],
            isActive: [model.isActive, Validators.required],
        });

        this.cdr.detectChanges();
    }

    save() {
        const controls = this.detailForm.controls;
        if (this.detailForm.invalid) {
            Object.keys(controls).forEach(controlName => {
                    controls[controlName].markAsTouched();
                }
            );
            return;
        }

        let data = this.prepareJSON(this.detailForm.value);

        if (this.data == null) {
            this.service.createItem(data).subscribe(resp => {
                    this.dialogRef.close(true);
                    this.cdr.detectChanges();
                },
                error => {
                    // let message = 'Ha ocurrido un error';
                    this._snackBar.open(error.error, 'OK', {
                        duration: 3000,
                    });
                });
        } else {
            this.service.updateItem(data, this.data.id).subscribe(() => {
                    this.dialogRef.close(true);
                },
                error => {
                    // let message = 'Ha ocurrido un error';
                    this._snackBar.open(error.error, 'OK', {
                        duration: 3000,
                    });
                });
        }
    }

    prepareJSON(data) {
        data.routes = this.routes;
        return data;
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    isControlHasError(controlName: string, validationType: string): boolean {
        const control = this.detailForm.controls[controlName];
        if (!control) {
            return false;
        }

        return control.hasError(validationType) && (control.dirty || control.touched);
    }

    addRoute() {
        let find = this.routes.find(route => route.codeRoute === this.routeInput.value);
        if (find) {
            return;
        }

        if (this.routeInput.value) {
            let newRoute = {
                codeRoute: this.routeInput.value,
                // transportId: this.data.id,
            };
            this.routes.push(newRoute);
            this.routeInput.setValue(null);
        } else {
            this.routeInput.markAsTouched();
            this.routeInput.setErrors({'required': true});
        }
    }

    deleteRoute(selectedRoute: any) {
        this.routes = this.routes.filter(route => route.codeRoute !== selectedRoute.codeRoute);
    }

    public getStructure() : void{
        this.countryService.getGrandfather().subscribe((value) => {
            this.provincias = value;
        });
    }
}
